module.exports = __webpack_public_path__ + "img/GH-syoukai-top-logo002.4b660856.webp";